import React, { useEffect, useState } from "react";
import {
  Navbar,
  Nav,
  Button,
  Offcanvas,
  Form,
  Container,
  Spinner,
  Table,
  DropdownButton,
  ButtonGroup,
  NavDropdown,
  Row,
  Col,
  Dropdown,
} from "react-bootstrap";
import "../style/admin.css";
import * as XLSX from "xlsx";
import { FaDownload, FaFilter } from "react-icons/fa";
import { RxHamburgerMenu } from "react-icons/rx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import axios from "axios";
import { apibasePath } from "../config";
import { Typography, Box } from "@mui/material";
const TotalOrderSummary = () => {
  const [logo, setLogo] = useState(null);
  const [brandLogo, setBrandLogo] = useState(null);
  const [name, setName] = useState(" ");
  const [show, setShow] = useState(false);
  const [orderSummary, setOrderSummary] = useState([]);
  const [itemCode, setItemCode] = useState([]);
  const [selectedItemCode, setSelectedItemCode] = useState("All");
  const [pagecount, setpageCount] = useState(1);
  const [totalPagescount, setTotalPagesCount] = useState();
  const [loading, setLoading] = useState(false);

  const Api_url = "https://broker.accountiez.com/client/profiles/company/";

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await axios.get(Api_url, {
          headers: { "Content-Type": "application/json" },
        });
        setLogo(response.data.logo);
        setName(response.data.name);
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    };
    fetchLogo();
  }, []);

  const Api = "https://broker.accountiez.com/client/profiles/brand/";

  useEffect(() => {
    const fetchdata = async () => {
      try {
        let response = await axios.get(Api, {
          headers: { "Content-Type": "application/json" },
        });
        console.log("responseeeeeeeeee", response);
        setBrandLogo(response.data.logo);
      } catch (error) {
        console.error(error);
      }
    };

    fetchdata();
  }, []);

  const orderSummaryData = async () => {
    try {
      const response = await axios.get(
        `${apibasePath}/order/item-order-summary/`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      console.log("orderSummaryData", response);
      const data = response?.data?.results || [];
      setOrderSummary(data);
    } catch (error) {
      console.error(error);
    }
  };

  const itemCodeList = async () => {
    try {
      const res = await axios.get(`${apibasePath}/order/items-with-orders/`, {
        headers: { "Content-Type": "application/json" },
      });
      console.log("res list", res);

      const codes = res.data.map((item) => item.item_code);
      setItemCode(codes);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    orderSummaryData();
    itemCodeList();
  }, []);

  const fetchFilteredData = async () => {
    try {
      const params = new URLSearchParams();
      if (selectedItemCode !== "All") {
        params.append("item_code", selectedItemCode);
      }
      if (pagecount) {
        params.append("page", pagecount);
      }
      const queryParam = params.toString();
      const res = await axios.get(
        `${apibasePath}/order/item-order-summary/?${queryParam}`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      console.log(res, "responseDataItemCode");
      const datas = res?.data?.results || [];

      setOrderSummary(datas);
      const totalCount = res.data.count || "Data is not available";
      console.log("Total Count:", totalCount);

      const totalPages = Math.ceil(totalCount / 10);
      console.log("totalPages", totalPages);

      // Set state
      setTotalPagesCount(totalPages);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchFilteredData();
  }, [selectedItemCode, pagecount]);

  const handleNext = () => {
    if (pagecount < totalPagescount) {
      const nextPage = pagecount + 1;
      setLoading(true);

      try {
        fetchFilteredData(nextPage); // Pass next page to API
        setpageCount(nextPage); // Update page after fetch
      } catch (error) {
        console.error("Error fetching next page:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handlePrevious = () => {
    if (pagecount > 1) {
      setpageCount((prevPage) => prevPage - 1);
    }
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // pdf

  const downloadPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text("Order Summary", 14, 15);

    const tableColumn = [
      "S.No",
      "Item Code",
      "Item Name",
      "Order Qty",
      "Gross Wt",
      "Stone Wt",
      "Net Wt",
    ];

    const tableRows = orderSummary.map((item, index) => [
      index + 1,
      item.item_code,
      item.item_name || "---",
      item.total_order_quantity,
      item.total_gross_weight,
      item.total_stone_weight,
      item.total_net_weight,
    ]);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 25,
      theme: "grid", // <-- This adds borders around every cell
      styles: {
        lineWidth: 0.1, // border thickness
        lineColor: [0, 0, 0], // black borders
        halign: "center",
        valign: "middle",
      },
      headStyles: {
        fillColor: [34, 105, 99], // Optional: color for header row
        textColor: 255,
        fontStyle: "bold",
      },
      tableLineColor: [0, 0, 0], // ensures full outer table borders
      tableLineWidth: 0.2,
    });

    doc.save("order-summary.pdf");
  };

  const fetchAllPagesData = async () => {
    const pageSize = 10; // Assuming 10 items per page, change as needed
    let currentPage = 1;
    let allData = [];

    while (true) {
      const params = new URLSearchParams();
      if (selectedItemCode !== "All") {
        params.append("item_code", selectedItemCode);
      }
      if (pagecount) {
        params.append("page", pagecount); // If you're passing pagecount directly, you may want to use `currentPage` instead of `pagecount`
      }
      const queryParam = params.toString();

      try {
        const res = await axios.get(
          `${apibasePath}/order/item-order-summary/?${queryParam}`,
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        console.log(res, "responseSummary");

        // Directly accessing the results from res.data
        const result = res?.data?.results;

        console.log(result, "result");

        // Check if result is an array or an object with data
        if (Array.isArray(result)) {
          if (result.length === 0) break; // No more data
          allData = [...allData, ...result];
        } else if (result && Array.isArray(result.data)) {
          // If it's a nested structure with a 'data' key
          allData = [...allData, ...result.data];
        } else {
          console.error("Unexpected result format:", result);
          break;
        }

        // If the number of items returned is less than the page size, we've hit the last page
        if (result.length < pageSize) break;

        currentPage++; // Increment page number
      } catch (error) {
        console.error("Error fetching data:", error);
        break; // Stop if there's an error
      }
    }

    return allData;
  };

  const exportToExcel = async () => {
    const allData = await fetchAllPagesData();

    const exportData = allData.map((item, index) => ({
      "S.No": index + 1,
      Item: item.item_code,
      "Item Name": item.item_name,
      Qty: item.total_order_quantity,
      "Gr Wt": item.total_gross_weight,
      "Tr Wt": item.total_stone_weight,
      "Net Wt": item.total_net_weight,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "OrderSummary");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, "OrderSummary.xlsx");
  };


  //   <NavDropdown
  //     title="EXHIBITION FORM"
  //     id="exhibition-dropdown"
  //     className="mt-2"
  //   >
  //     <NavDropdown.Item href="/createcustomer">
  //       • CREATE CUSTOMER
  //     </NavDropdown.Item>
  //     <NavDropdown.Item href="/orderentryform">
  //       • ORDER ENTRY FORM
  //     </NavDropdown.Item>
  //     <NavDropdown.Item href="/orderformprint">
  //       • ORDER FORM PRINT
  //     </NavDropdown.Item>
  //     <NavDropdown.Item href="/totalorderssummary">
  //       • TOTAL ORDERS SUMMARY
  //     </NavDropdown.Item>
  //   </NavDropdown>
  // );
  return (
    <>
    

      {/* Main Content */}
      <main className="content">
        {/* page content */}
        {/* Top Filters */}
        <div className="header-section">
          <Row
            className="align-items-center mb-3"
            style={{ width: "100%", gap: "10px" }}
          >
            <Col
              xs={12}
              md={6}
              lg={4}
              className="d-flex align-items-center mb-2 mb-md-0"
              style={{ width: "75%" }}
            >
              <strong className="me-2 fs-5" style={{ color: "#194D52" }}>
                Item Code :
              </strong>
              <Form.Select
                className="w-50"
                style={{ color: "#194D52", fontWeight: "bold" }}
                value={selectedItemCode}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  setSelectedItemCode(selectedValue);
                  setpageCount(1);
                }}
              >
                <option value="All">All</option>
                {itemCode.map((code, index) => (
                  <option key={index} value={code}>
                    {code}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col xs={6} sm={6} md={2}>
              <Dropdown className="w-100">
                <Dropdown.Toggle
                  className="w-100 "
                  style={{ backgroundColor: "#226963" }}
                >
                  <FaDownload />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={downloadPDF}>
                    Download PDF
                  </Dropdown.Item>
                  <Dropdown.Item onClick={exportToExcel}>
                    Download Excel
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>
        </div>
        <Table className="table" responsive striped bordered hover>
          <thead>
            <tr style={{ color: "#35646E", borderBottom: "1px solid black" }}>
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                S.No
              </th>
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                Item
              </th>
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                Item Name
              </th>
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                Qty
              </th>

              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                Gr Wt
              </th>
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                Tr Wt
              </th>
              <th
                style={{
                  backgroundColor: "#C5CACF",
                  color: "#35646E",
                  fontFamily: "Roboto",
                }}
              >
                Net Wt
              </th>
            </tr>
          </thead>
          <tbody>
            {orderSummary.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.item_code}</td>
                <td>{item.item_name || "---"}</td>
                <td>{item.total_order_quantity}</td>

                <td>{item.total_gross_weight}</td>
                <td>{item.total_stone_weight}</td>
                <td>{item.total_net_weight}</td>
              </tr>
            ))}
          </tbody>
          <tbody></tbody>
        </Table>

        <Box sx={{ mr: 5 }}>
          <Box
            mt={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <ButtonGroup>
              <Button
                style={{ backgroundColor: "#226963" }}
                onClick={handlePrevious}
                sx={{ border: "1px solid", mr: 1 }}
                disabled={pagecount === 1}
              >
                Previous
              </Button>
              <Typography sx={{ px: 2, my: 1, color: "#850101" }}>
                Page {pagecount}
              </Typography>
              <Button
                style={{ backgroundColor: "#226963" }}
                onClick={handleNext}
                sx={{ border: "1px solid" }}
                disabled={
                  loading ||
                  pagecount >= totalPagescount ||
                  totalPagescount === 0
                }
              >
                {loading ? "Loading..." : "Next"}
              </Button>
            </ButtonGroup>
          </Box>
        </Box>
       
      </main>
    </>
  );
};

export default TotalOrderSummary;
